module.exports = __webpack_public_path__ + "static/media/bottlings14.1e832de0.jpg";